import type { WalletAsset } from "@/interfaces/asset";
import Decimal from "decimal.js";

export type LockedWalletData = {
  total: string;
  trade: string;
  transfer: string;
  withdrawal: string;
  deposit: string;
  currency: string;
};

export const aggregateLockedFunds = (
  assets: WalletAsset[] = [],
  currency = "USD",
): LockedWalletData => {
  const trade = assets.reduce(
    (sum, asset) => sum.plus(asset.lockedTrade || 0),
    new Decimal(0),
  );

  const transfer = assets.reduce(
    (sum, asset) => sum.plus(asset.lockedTransfer || 0),
    new Decimal(0),
  );

  const withdrawal = assets.reduce(
    (sum, asset) => sum.plus(asset.lockedWithdrawal || 0),
    new Decimal(0),
  );

  const deposit = assets.reduce(
    (sum, asset) => sum.plus(asset.lockedDeposit || 0),
    new Decimal(0),
  );

  const total = trade.plus(transfer).plus(withdrawal).plus(deposit);

  return {
    total: total.toFixed(),
    trade: trade.toFixed(),
    transfer: transfer.toFixed(),
    withdrawal: withdrawal.toFixed(),
    deposit: deposit.toFixed(),
    currency,
  };
};
